"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const react_query_1 = require("react-query");
const keyFactory_1 = require("../keyFactory");
/**
 *
 * @param firestore Instancia de Firestore
 * @param type Mediante que permiso estamos buscando al provider
 * @param specialty La especialidad del provider
 * @param queryOptions
 * @returns
 */
function useAvailableDoctors(firestore, type, specialty, queryOptions) {
    return (0, react_query_1.useQuery)(keyFactory_1.FirestoreKeys.Providers({
        name: "avaibleDoctors",
        path: "providers"
    }, [type, specialty ?? "withoutSpeciality"]), async function () {
        const refDoctors = (0, firestore_1.collectionGroup)(firestore, "availablePermissions");
        const queryDoctors = (0, firestore_1.query)(refDoctors, (0, firestore_1.where)("type", "==", type), (0, firestore_1.where)("active", "==", true));
        const onlineActive = [];
        const querySnapshot = await (0, firestore_1.getDocs)(queryDoctors);
        const promises = [];
        querySnapshot.forEach(async (provider) => {
            // utilizamos .parent.parent para subir dos niveles y obtener la referencia del documento padre, que es el documento de usuario al que pertenece la colección "availablePermissions". A partir de esa referencia, podemos obtener el ID del usuario
            const userUid = provider.ref.parent.parent?.id;
            const providerRef = (0, firestore_1.doc)(firestore, `providers/${userUid}`);
            const document = (0, firestore_1.getDoc)(providerRef).then((providerDocument) => {
                // Si no nos pasan especialidad, pusheamos a todos los especialistas, caso contrario, solo a los que correspondan a la especialidad
                if (providerDocument.exists() && !specialty) {
                    onlineActive.push({ ...providerDocument.data(), uid: providerDocument.id });
                    return;
                }
                if (providerDocument.exists() && providerDocument.data().matricula_especialidad === specialty) {
                    onlineActive.push({ ...providerDocument.data(), uid: providerDocument.id });
                }
            });
            promises.push(document);
        });
        // Hago esto porque forEach no es el mejor amígo de los callbacks ascíncronos
        await Promise.all(promises);
        return onlineActive;
    }, queryOptions);
}
exports.default = useAvailableDoctors;
